import './style.scss'

import Title from 'components/Title'
import RichText from 'components/RichText'

export default {
  name: 'ContactSection',
  props: ['title', 'items'],
  render (h) {
    const { title, items } = this
    return (
      <div class='ContactSection'>
        <Title class='ContactSection__title' level={2} id={title}>{title}</Title>
        <div class='ContactSection__items'>
          {items.map(i => (
            <div class='ContactSection__item'>
              <RichText content={i.content} />
            </div>
          ))}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/ContactSection/index.js